<template>
  <div class="klickbox-edit-code clearfix" v-if="step.kind === 'email'">
    <div class="klickbox-edit-col">
      <div class="kp-modular-label">{{ $t('edit.canvas.mail_service') }}</div>
      <textarea
        class="klickbox-code-input klickbox-code__area"
        id="kp-import-form-input"
        :placeholder="$t('edit.canvas.mail_service_text_area')"
        :value="orginalForm"
        @change="stepUpdateFormHtml({ html: $event.target.value, id: step.id, customizedForm })"></textarea>
    </div>

    <div class="klickbox-edit-col">
      <div class="kp-modular-row clearfix">
        <label class="kp-modular-label">{{ $t('edit.canvas.custom_html_form') }}</label>
        <div class="kp-modular-check kp-modular-check-without-icon">
          <input type="checkbox" :checked="step.customized_form" @change="stepUpdateCustomizedForm({ event: $event, id: step.id })"><span></span>
        </div>
      </div>

      <div class="kp-modular-row clearfix">
        <label class="kp-modular-label">{{ $t('edit.canvas.redirect_by_mail_service') }}</label>
        <div class="kp-modular-check kp-modular-check-without-icon">
          <input type="checkbox" :checked="step.redirect_email_service" @change="stepUpdateRedirectEmailService({ event: $event, id: step.id })"><span></span>
        </div>
      </div>

      <exception-select v-show="!redirect" :selected="jump[0].destination_step_id" :jump="jump[0]"></exception-select>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ExceptionSelect from '../../../sidebar/steps/jump/selects/Exception.vue';

export default {
  components: {
    ExceptionSelect,
  },
  computed: mapGetters({
    step: 'stepActive',
    jump: 'jumpList',
    redirect: 'stepRedirectEmailService',
    customizedForm: 'stepCustomizedForm',
    orginalForm: 'stepOriginalFormHtmlDecoded',
  }),
  methods: mapActions([
    'stepUpdateFormHtml',
    'stepUpdateCustomizedForm',
    'stepUpdateRedirectEmailService',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Email.vue?3815e9c0
 **/